export const getAvoidList = 'step4/getAvoidList';
export const getTagKeysList = 'step4/getTagKeysList';
export const getProjects = 'step4/getProjects';
export const describeTagValues = 'step4/describeTagValues';
export const getAvoidPackage = 'step4/getAvoidPackage';
export const createAviod = 'step4/createAviod';
export const calcAvoidPrice = 'step4/calcAvoidPrice';
export const describeKeys = 'step4/describeKeys';
export const describeKecIamRoles = 'step4/describeKecIamRoles';
export const getTimeddelDate = 'step4/getTimeddelDate';
export const CheckKeyEncryption = 'step4/CheckKeyEncryption';